import { Routes } from '@angular/router';

export const sectorModuleRoutes: Routes = [
  { path: '', redirectTo: 'overview', pathMatch: 'full', data: { isNotAMenuItem: true } },
  {
    path: 'overview',
    loadComponent: () =>
      import('../me-sector-dashboard/me-sector-dashboard').then((m) => m.MeSectorDashboard),
    data: {
      name: 'Overview',
      icon: 'dashboard',
      iconType: 'MAT',
    },
  },
  {
    path: 'institution-list',
    loadComponent: () =>
      import('../sector-institution-list/sector-institution-list').then((m) => m.SectorInstitutionList),
    data: {
      name: 'Institutions',
      icon: 'apartment',
      iconType: 'MAT',
    },
  },
  {
    path: 'institution-list/:id',
    loadComponent: () =>
      import('../sector-institution-list/sector-institution-details/sector-institution-details').then((m) => m.SectorInstitutionDetails),
    data: {
      isNotAMenuItem: true
    },
  },
  {
    path: 'reporting',
    data: {
      name: 'Reporting',
      icon: 'summarize',
      iconType: 'MAT',
    },
    children: [
      { path: '', redirectTo: 'hub', pathMatch: 'full', data: { isNotAMenuItem: true } },
      {
        path: 'hub',
        loadComponent: () =>
          import('../reporting/reporting').then((m) => m.Reporting),
        data: {
          isNotAMenuItem: true,
        }
      },
      {
        path: 'other-charges-budget',
        loadComponent: () =>
          import('../reporting/other-charges-budget/other-charges-budget').then((m) => m.OtherChargesBudgetReport),
        data: {
          name: 'OC Budget AAP',
        }
      },
      {
        path: 'development-project',
        loadComponent: () =>
          import('../reporting/development-project/development-project').then((m) => m.DevelopmentProjectReport),
        data: {
          name: 'Project AAP',
        }
      },
      {
        path: 'annual-me-matrix',
        loadComponent: () =>
          import('../reporting/annual-me-matrix/annual-me-matrix').then((m) => m.AnnualMeMatrixReport),
        data: {
          name: 'Annual M&E Plan matrix',
        }
      },
      {
        path: 'quarterly-performance',
        loadComponent: () =>
          import('../reporting/quarterly-performance/quarterly-performance').then((m) => m.QuarterlyPerformanceReport),
        data: {
          name: 'Quarterly by Implementation',
        }
      },
      {
        path: 'dynamic-quarterly',
        loadComponent: () =>
          import('../reporting/dynamic-quarterly/dynamic-quarterly').then((m) => m.DynamicQuarterlyReport),
        data: {
          name: 'Summary of Performance Report',
        }
      },
      {
        path: 'implementation-performance-contract',
        loadComponent: () =>
          import('../reporting/implementation-performance-contract/implementation-performance-contract').then((m) => m.ImplementationPerformanceContractReport),
        data: {
          name: 'Implementation Performance Contract Report',
        }
      },
      {
        path: 'other-charges-implementation',
        loadComponent: () =>
          import('../reporting/other-charges-implementation/other-charges-implementation').then((m) => m.OtherChargesImplementationReport),
        data: {
          name: 'Other Charges (OC) Implementation Report',
        }
      },
      {
        path: 'directorate-performance',
        loadComponent: () =>
          import('../reporting/directorate-performance/directorate-performance').then((m) => m.DirectoratePerformanceReport),
        data: {
          name: 'Directorate/Unit Monitoring Report',
        }
      },
      {
        path: 'action-plan-monitoring',
        loadComponent: () =>
          import('../reporting/action-plan-monitoring/action-plan-monitoring').then((m) => m.ActionPlanMonitoringReport),
        data: {
          name: 'Annual Action Plan Monitoring Report',
        }
      },
      {
        path: 'institution-performance',
        loadComponent: () =>
          import('../reporting/institution-performance/institution-performance').then((m) => m.InstitutionPerformanceReport),
        data: {
          name: 'Institutional Performance Report',
        }
      },
      {
        path: 'framework-sample',
        loadComponent: () =>
          import('../reporting/framework-sample/framework-sample').then((m) => m.FrameworkSampleReport),
        data: {
          name: 'Framework Report',
        }
      },
      {
        path: 'board-committee',
        loadComponent: () =>
          import('../reporting/board-committee/board-committee').then((m) => m.BoardCommitteeReport),
        data: {
          name: 'Board Committee Report',
        }
      }
    ]
  },
  {
    path: 'reporting/gpr-reporting',
    loadComponent: () =>
      import('../reporting/gpr-reporting/gpr-reporting').then((m) => m.GprReporting),
    data: {
      isNotAMenuItem: true,
    },
  },
  {
    path: 'reporting/evaluation-report',
    loadComponent: () =>
      import('../reporting/evaluation-report/evaluation-report').then((m) => m.EvaluationReport),
    data: {
      isNotAMenuItem: true,
    },
  },
  {
    path: 'reporting/monitoring-report',
    loadComponent: () =>
      import('../reporting/monitoring-report/monitoring-report').then((m) => m.MonitoringReport),
    data: {
      isNotAMenuItem: true,
    },
  },
  {
    path: 'monitoring-plan',
    loadComponent: () =>
      import('../monitoring-plan-list/monitoring-plan-list').then((m) => m.MonitoringPlanList),
    data: {
      name: 'Monitoring Plan',
      icon: 'summarize',
      iconType: 'MAT',
    },
  },
  {
    path: 'evaluation-plan-list',
    loadComponent: () =>
      import('../evaluation-plan-list/evaluation-plan-list').then((m) => m.EvaluationPlanList),
    data: {
      name: 'Evaluation Plans',
      icon: 'list',
      iconType: 'MAT',
    },
  },
  {
    path: 'project-list',
    loadComponent: () =>
      import('../development-project-list/development-project-list').then((m) => m.DevelopmentProjectList),
    data: {
      name: 'Development Projects',
      icon: 'folder',
      iconType: 'MAT',
    },
  },
  {
    path: 'project-list/:id',
    loadComponent: () =>
      import('../development-project-list/project-details/project-details').then((m) => m.ProjectDetails),
    data: {
      isNotAMenuItem: true,
    },
  },
  {
    path: 'notification-management',
    loadComponent: () =>
      import('../development-project-list/development-project-list').then((m) => m.DevelopmentProjectList),
    data: {
      name: 'Notification Management',
      icon: 'notifications',
      iconType: 'MAT',
    },
  },
];

